import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Grid,
  Typography,
  Paper,
  ListItem,
} from '@material-ui/core';

import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';

import { classTypeMap, classIconMap } from '../../shared/Mappings';
import {
  truncate,
  createProfileRoute,
  getLanguageNameByCode,
  renderDailyScheduleNoTimeZone,
  grabClassTimes,
} from '../../shared/Helpers';

const styles = theme => ({
  mypaper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
  },
  timezone: {
    paddingTop: theme.spacing(),
    fontSize: '13px',
  },
  span: {
    fontSize: 13,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
    letterSpacing: 1,
  },
  listItem: {
    padding: 0,
  },
  trainerImg: {
    height: '140px',
    width: '140px',
  },
  trainerName: {
    textTransform: 'uppercase',
    color: theme.palette.primary.dark,
  },
  trainerLink: {
    fontSize: 18,
    letterSpacing: 2,
    textTransform: 'uppercase',
    // fontSize: 16,
    fontWeight: 'bold',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
    '&:visited': {
      color: theme.palette.primary.dark,
    },
  },
  teacherName: {
    marginTop: theme.spacing(),
    textAlign: 'center',
  },
  eventName: {
    textTransform: 'uppercase',
    letterSpacing: 3,
    [theme.breakpoints.down(800)]: {
      marginTop: theme.spacing(),
      fontSize: 24,
    },
  },
  extra: {
    textTransform: 'none',
    letterSpacing: 1,
    fontSize: '24px',
  },
  beltIcon: {
    height: 48,
    width: 48,
    verticalAlign: 'text-bottom',
    marginLeft: theme.spacing(2),
  },
  price: {
    padding: theme.spacing(2),
  },
  detailsButton: {
    marginRight: 4,
    marginLeft: 4,
  },
  buttonContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginRight: theme.spacing(),
  },
  infoText: {
    // paddingTop: theme.spacing(),
  },
  contentArea: {
    height: '100%',
    [theme.breakpoints.up(800)]: {
      marginLeft: theme.spacing(2),
    },
  },
  imgArea: {
    [theme.breakpoints.down(800)]: {
      textAlign: 'center',
    },
  },
  imgDiv: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  locationLink: {
    textDecoration: 'none',
    color: theme.palette.blue,
    '&:visited': {
      color: theme.palette.blue,
    },
  },
  info: {
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
});

const ClassListItem = ({
  user,
  classes,
  currentClass,
}) => (
  <Paper className={classes.mypaper}>
    <ListItem className={classes.listItem}>
      <Grid container>
        <Grid item xs={12} sm={3} className={classes.imgArea}>
          <div className={classes.imgDiv}>
            <IconButton href={createProfileRoute(user.username)} className={classes.iconButton}>
              <Avatar alt="trainer profile" src={currentClass.user_img || classIconMap[currentClass.class_type]} className={classes.trainerImg} />
            </IconButton>
            <div className={classes.teacherName}>
              <a target="_blank" rel="noopener noreferrer" className={classes.trainerLink} href={createProfileRoute(user.username)}>
                {' ' + user.first_name + ' ' + user.last_name}
              </a>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid container className={classes.contentArea}>
            <Grid item xs={10}>
              <Typography variant="h4" className={classes.eventName}>
                {classTypeMap[currentClass.class_type]}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.rightColumnTop}>
              <img src={classIconMap[currentClass.class_type]} alt="belt icon" className={classes.beltIcon} />
            </Grid>
            <Grid item xs={12} className={classes.info}>
              <Typography color="textPrimary" className={classes.infoText} variant="body1">
                <span className={classes.span}>Day/Time:&nbsp;</span>
                {renderDailyScheduleNoTimeZone(grabClassTimes(currentClass))}
                {currentClass.timezone && (
                  <span>{' (' + currentClass.timezone + ')'}</span>
                )}
              </Typography>
              {currentClass.attendance_type === 'online'
                ? (
                  <Typography color="textPrimary" className={classes.infoText} variant="body1">
                    <span className={classes.span}>Location:</span>
                    {' Online'}
                  </Typography>
                )
                : (
                  <React.Fragment>
                    {currentClass.location !== null && (
                      <Typography color="textPrimary" className={classes.infoText} variant="body1">
                        <span className={classes.span}>Location:</span>
                        <a target="_blank" rel="noopener noreferrer" href={'/location/' + currentClass.location.id} className={classes.locationLink}>{ ' ' + currentClass.location.title}</a>
                      </Typography>
                    )}
                  </React.Fragment>
                )
              }
              {currentClass.language !== '' && (
                <Typography color="textPrimary" className={classes.infoText} variant="body1">
                  <span className={classes.span}>Language:</span>
                  { ' ' + getLanguageNameByCode(currentClass.language)}
                </Typography>
              )}
              {currentClass.description !== '' && (
                <Typography color="textPrimary" variant="body1" className={classes.infoText}>
                  <span className={classes.span}>Description:</span>
                  {' ' + truncate(currentClass.description, 130)}
                </Typography>
              )}
              {currentClass.cost !== '' && (
                <Typography color="textPrimary" variant="body1" className={classes.infoText}>
                  <span className={classes.span}>Cost:</span>
                  {' ' + truncate(currentClass.cost, 135)}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttonContainer}>
                {/* {currentClass.location !== null && <Button variant="outlined" onClick={() => handleShowOnMap(currentClass.id)} className={classes.button}>Show on Map</Button>} */}
                <Button variant="outlined" href={'/class/' + currentClass.id} className={classes.button}>Class Details</Button>
                <Button variant="contained" target="_blank" href={currentClass.link} className={classes.button} color="secondary">Join / Register</Button>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ListItem>
  </Paper>
);

ClassListItem.propTypes = {
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  currentClass: PropTypes.object.isRequired,
  classTimezone: PropTypes.string.isRequired,
};

export default withStyles(styles)(ClassListItem);
